/*
 * AutoCAD 2017 2018 Color Index (1-255) as RGB + ALPHA colors
 */

const colorIndex = [
  [0, 0, 0, 255], // index 0, added for easy maintenance
  // 1
  [255, 0, 0, 255],
  [255, 255, 0, 255],
  [0, 255, 0, 255],
  [0, 255, 255, 255],
  [0, 0, 255, 255],
  [255, 0, 255, 255],
  [255, 255, 255, 255],
  [128, 128, 128, 255],
  [192, 192, 192, 255],
  [255, 0, 0, 255],
  // 11
  [255, 127, 127, 255],
  [165, 0, 0, 255],
  [165, 82, 82, 255],
  [127, 0, 0, 255],
  [127, 63, 63, 255],
  [76, 0, 0, 255],
  [76, 38, 38, 255],
  [38, 0, 0, 255],
  [38, 19, 19, 255],
  [255, 63, 0, 255],
  // 21
  [255, 159, 127, 255],
  [165, 41, 0, 255],
  [165, 103, 82, 255],
  [127, 31, 0, 255],
  [127, 79, 63, 255],
  [76, 19, 0, 255],
  [76, 47, 38, 255],
  [38, 9, 0, 255],
  [38, 28, 19, 255],
  [255, 127, 0, 255],
  // 31
  [255, 191, 127, 255],
  [165, 82, 0, 255],
  [165, 124, 82, 255],
  [127, 63, 0, 255],
  [127, 95, 63, 255],
  [76, 38, 0, 255],
  [76, 57, 38, 255],
  [38, 19, 0, 255],
  [38, 28, 19, 255],
  [255, 191, 0, 255],
  // 41
  [255, 223, 127, 255],
  [165, 124, 0, 255],
  [165, 145, 82, 255],
  [127, 95, 0, 255],
  [127, 111, 63, 255],
  [76, 57, 0, 255],
  [76, 66, 38, 255],
  [38, 28, 0, 255],
  [38, 33, 19, 255],
  [255, 255, 0, 255],
  // 51
  [255, 255, 127, 255],
  [165, 165, 0, 255],
  [165, 165, 82, 255],
  [127, 127, 0, 255],
  [127, 127, 63, 255],
  [76, 76, 0, 255],
  [76, 76, 38, 255],
  [38, 38, 0, 255],
  [38, 38, 19, 255],
  [191, 255, 0, 255],
  // 61
  [223, 255, 127, 255],
  [124, 165, 0, 255],
  [145, 165, 82, 255],
  [95, 127, 0, 255],
  [111, 127, 63, 255],
  [57, 76, 0, 255],
  [66, 76, 38, 255],
  [28, 38, 0, 255],
  [33, 38, 19, 255],
  [127, 255, 0, 255],
  // 71
  [191, 255, 127, 255],
  [82, 165, 0, 255],
  [124, 165, 82, 255],
  [63, 127, 0, 255],
  [95, 127, 63, 255],
  [38, 76, 0, 255],
  [57, 76, 38, 255],
  [19, 38, 0, 255],
  [28, 38, 19, 255],
  [63, 255, 0, 255],
  // 81
  [159, 255, 127, 255],
  [41, 165, 0, 255],
  [103, 165, 82, 255],
  [31, 127, 0, 255],
  [79, 127, 63, 255],
  [19, 76, 0, 255],
  [47, 76, 38, 255],
  [9, 38, 0, 255],
  [23, 38, 19, 255],
  [0, 255, 0, 255],
  // 91
  [125, 255, 127, 255],
  [0, 165, 0, 255],
  [82, 165, 82, 255],
  [0, 127, 0, 255],
  [63, 127, 63, 255],
  [0, 76, 0, 255],
  [38, 76, 38, 255],
  [0, 38, 0, 255],
  [19, 38, 19, 255],
  [0, 255, 63, 255],
  // 101
  [127, 255, 159, 255],
  [0, 165, 41, 255],
  [82, 165, 103, 255],
  [0, 127, 31, 255],
  [63, 127, 79, 255],
  [0, 76, 19, 255],
  [38, 76, 47, 255],
  [0, 38, 9, 255],
  [19, 88, 23, 255],
  [0, 255, 127, 255],
  // 111
  [127, 255, 191, 255],
  [0, 165, 82, 255],
  [82, 165, 124, 255],
  [0, 127, 63, 255],
  [63, 127, 95, 255],
  [0, 76, 38, 255],
  [38, 76, 57, 255],
  [0, 38, 19, 255],
  [19, 88, 28, 255],
  [0, 255, 191, 255],
  // 121
  [127, 255, 223, 255],
  [0, 165, 124, 255],
  [82, 165, 145, 255],
  [0, 127, 95, 255],
  [63, 127, 111, 255],
  [0, 76, 57, 255],
  [38, 76, 66, 255],
  [0, 38, 28, 255],
  [19, 88, 88, 255],
  [0, 255, 255, 255],
  // 131
  [127, 255, 255, 255],
  [0, 165, 165, 255],
  [82, 165, 165, 255],
  [0, 127, 127, 255],
  [63, 127, 127, 255],
  [0, 76, 76, 255],
  [38, 76, 76, 255],
  [0, 38, 38, 255],
  [19, 88, 88, 255],
  [0, 191, 255, 255],
  // 141
  [127, 223, 255, 255],
  [0, 124, 165, 255],
  [82, 145, 165, 255],
  [0, 95, 127, 255],
  [63, 111, 217, 255],
  [0, 57, 76, 255],
  [38, 66, 126, 255],
  [0, 28, 38, 255],
  [19, 88, 88, 255],
  [0, 127, 255, 255],
  // 151
  [127, 191, 255, 255],
  [0, 82, 165, 255],
  [82, 124, 165, 255],
  [0, 63, 127, 255],
  [63, 95, 127, 255],
  [0, 38, 76, 255],
  [38, 57, 126, 255],
  [0, 19, 38, 255],
  [19, 28, 88, 255],
  [0, 63, 255, 255],
  // 161
  [127, 159, 255, 255],
  [0, 41, 165, 255],
  [82, 103, 165, 255],
  [0, 31, 127, 255],
  [63, 79, 127, 255],
  [0, 19, 76, 255],
  [38, 47, 126, 255],
  [0, 9, 38, 255],
  [19, 23, 88, 255],
  [0, 0, 255, 255],
  // 171
  [127, 127, 255, 255],
  [0, 0, 165, 255],
  [82, 82, 165, 255],
  [0, 0, 127, 255],
  [63, 63, 127, 255],
  [0, 0, 76, 255],
  [38, 38, 126, 255],
  [0, 0, 38, 255],
  [19, 19, 88, 255],
  [63, 0, 255, 255],
  // 181
  [159, 127, 255, 255],
  [41, 0, 165, 255],
  [103, 82, 165, 255],
  [31, 0, 127, 255],
  [79, 63, 127, 255],
  [19, 0, 76, 255],
  [47, 38, 126, 255],
  [9, 0, 38, 255],
  [23, 19, 88, 255],
  [127, 0, 255, 255],
  // 191
  [191, 127, 255, 255],
  [165, 0, 82, 255],
  [124, 82, 165, 255],
  [63, 0, 127, 255],
  [95, 63, 127, 255],
  [38, 0, 76, 255],
  [57, 38, 126, 255],
  [19, 0, 38, 255],
  [28, 19, 88, 255],
  [191, 0, 255, 255],
  // 201
  [223, 127, 255, 255],
  [124, 0, 165, 255],
  [142, 82, 165, 255],
  [95, 0, 127, 255],
  [111, 63, 127, 255],
  [57, 0, 76, 255],
  [66, 38, 76, 255],
  [28, 0, 38, 255],
  [88, 19, 88, 255],
  [255, 0, 255, 255],
  // 211
  [255, 127, 255, 255],
  [165, 0, 165, 255],
  [165, 82, 165, 255],
  [127, 0, 127, 255],
  [127, 63, 127, 255],
  [76, 0, 76, 255],
  [76, 38, 76, 255],
  [38, 0, 38, 255],
  [88, 19, 88, 255],
  [255, 0, 191, 255],
  // 221
  [255, 127, 223, 255],
  [165, 0, 124, 255],
  [165, 82, 145, 255],
  [127, 0, 95, 255],
  [127, 63, 111, 255],
  [76, 0, 57, 255],
  [76, 38, 66, 255],
  [38, 0, 28, 255],
  [88, 19, 88, 255],
  [255, 0, 127, 255],
  // 231
  [255, 127, 191, 255],
  [165, 0, 82, 255],
  [165, 82, 124, 255],
  [127, 0, 63, 255],
  [127, 63, 95, 255],
  [76, 0, 38, 255],
  [76, 38, 57, 255],
  [38, 0, 19, 255],
  [88, 19, 28, 255],
  [255, 0, 63, 255],
  // 241
  [255, 127, 159, 255],
  [165, 0, 41, 255],
  [165, 82, 103, 255],
  [127, 0, 31, 255],
  [127, 63, 79, 255],
  [76, 0, 19, 255],
  [76, 38, 47, 255],
  [38, 0, 9, 255],
  [88, 19, 23, 255],
  [0, 0, 0, 255],
  // 251
  [101, 101, 101, 255],
  [102, 102, 102, 255],
  [153, 153, 153, 255],
  [204, 204, 204, 255],
  [255, 255, 255, 255]
]

module.exports = colorIndex
